import _ from 'lodash';

export function attachIds(questions) {
  return _.map(questions, (q, id) => {
    return { ...q, id };
  });
}